<template>
    <section class="autocomplete input-group">
        <span style="position:absolute; top: 5px; right: 50px; color: red">x</span>
        <input type="text" placeholder="Пошук" v-model="query" v-on:keyup.esc="clear" v-on:keyup="autoComplete"
               v-on:focus="open=true"
               class="form-control search">
        <div class="result-panel p-1 pt-3 p-lg-5" :style="h_style" v-if="open">
            <div class="content">
                <div class="row">
                    <div class="col-12 col-lg-7">
                        <div class="row">
                            <div class="col">
                                <ul>
                                    <li v-for="product in products" class="mb-1">
                                        <a :href="'/product/'+product.id">{{ locale === 'ru' ? product.name : product.name_uk }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col">
                                <h4>{{ translate('categories') }}</h4>
                                <ul>
                                    <li v-for="catalog in catalogs" class="mt-1">
                                        <a :href="'/catalog/'+catalog.id">
                                            {{ locale === 'ru' ? catalog.menu_name : catalog.menu_name_uk}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-5 pt-5 pt-lg-1">
                        <h4>{{ translate('popular') }}</h4>
                        <div class="row" v-for="product in products.slice(0, 3)">
                            <a :href="'/product/'+product.id" class="pt-2">
                                <div class="col-6">
                                    <img :src="'/images/products/medium_'+product.id+'.jpg'" alt="main image"
                                         style="height: auto">
                                </div>
                                <div class="col-12">
                                    <div class="product_name tw-text-left tw-pt-5">
                                        <div class="pl-2 pr-4">
                                            {{ locale === 'ru' ? product.name : product.name_uk }}
                                        </div>
                                        <div class="tw-text-xl tw-pl-2 tw-pb-3 sale_price">
                                            {{ product.real_price }}
                                        </div>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="input-group-addon" v-on:click="clear"><i class="fa fa-times"></i></div>
        <div v-if="!wait" class="input-group-addon"><i class="fa fa-search"></i></div>
        <div v-else class="input-group-addon"><i class="fa fa-spinner fa-spin"></i></div>

    </section>
</template>

<script>
export default {
    name: "Search",
    props: ['locale','h_style'],
    data() {
        return {
            // open: false,
            query: '',
            wait: false,
            products: [],
            catalogs: [],
            trans: {
                'categories': {
                    'ru': 'Категории',
                    'uk': 'Категорії',
                },
                'popular': {
                    'ru': 'Популярные товары',
                    'uk': 'Популярні товари',
                }
            }
        }
    },
    computed:{
        open(){
            return this.products.length>0 || this.catalogs.length>0
        },
    },
    methods: {

        autoComplete() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                if (this.query.length > 0) {
                    this.results = [];
                    this.wait = true;
                    axios.get('/api/smart-search', {params: {query: this.query}})
                        .then(response => {
                            this.products = response.data.products;
                            this.catalogs = response.data.catalogs;
                            // console.log(this.results);
                            // console.log(response.data.products);
                            this.wait = false;
                        });
                }
            }, 1000);

        },
        clear() {
            this.query = '';
            this.wait = false;
            this.catalogs = [];
            this.products = [];
        },
        translate(sentence) {
            return this.trans[sentence][this.locale];
        },
    }
}
</script>

<style scoped>
.autocomplete {
    position: relative;
}

.search:focus {
    box-shadow: inset 0 -1px 0 #ddd;
}

.result-panel {
    position: absolute;
    background: white;
    width: 100%;
    /*height: 200px;*/
    overflow-y: scroll;
    overflow-x: hidden;
    /*max-height: 200px;*/
    z-index: 1000;
    margin-top: 40px;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
}

.input-group-addon {
    background-color: #0e8ce4;
    color: white;
}
</style>
